const CONNECTION = {
    LOGIN: {
        url: '/login'
    },
    LOGIN_MFA: {
        url: '/verifyTotpForLogin'
    },
    LOGOUT: {
        url: '/logout'
    },
    FORCE_LOGIN: {
        url: '/login'
    },
    CONNECT_AS: {
        url: '/users/:userId/loginAs'
    }
};

export default CONNECTION;